// SPDX-FileCopyrightText: 2025 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import { get } from '@tls/auth';
import { CameraCalibration } from '@tls/sw91-communication/types/com.base';
import { useEffect, useState } from 'react';

export const DEFAULT_CAMERA_CALIBRATON: CameraCalibration = {
  imageWidth: 0,
  imageHeight: 0,
  scaleFactorX: 1,
  scaleFactorY: 1,
};

const useCameraCalibration = projectId => {
  const [cameraCalibration, setCameraCalibration] = useState<CameraCalibration>();

  useEffect(() => {
    if (!projectId) return;

    // Fetch the camera calibration data for the project
    const fetchCameraCalibration = async () => {
      try {
        const response = await get(`projects/${projectId}/camera-calibration`);
        const cameraCalibration: CameraCalibration = response.data.cameraCalibration;
        setCameraCalibration(cameraCalibration);
      } catch (error) {
        console.error('Failed to fetch camera calibration data:', error);
      }
    };

    fetchCameraCalibration();
  }, [projectId]);

  return cameraCalibration ?? DEFAULT_CAMERA_CALIBRATON;
};

export default useCameraCalibration;
